var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEllipsisV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.648,
    height: 16,
    viewBox: "0 0 3.648 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-ellipsis-v",
    "data-name": "Icon awesome-ellipsis-v",
    d: "M3.511,5.739A1.824,1.824,0,1,1,1.688,7.563,1.823,1.823,0,0,1,3.511,5.739ZM1.688,1.386A1.824,1.824,0,1,0,3.511-.437,1.823,1.823,0,0,0,1.688,1.386Zm0,12.352a1.824,1.824,0,1,0,1.824-1.824A1.823,1.823,0,0,0,1.688,13.739Z",
    transform: "translate(-1.688 0.438)",
    fill: "#102250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEllipsisV);
export default __webpack_public_path__ + "static/media/icon-ellipsis-v.afa8b08bc9c9c931c18a5bdcf37fc269.svg";
export { ForwardRef as ReactComponent };